import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { compress, decompress } from "lz-string";
import { preSerialize, preDeserialize } from "../utils/sessionStorage";

const smallDataQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const sessionStoragePersister = createSyncStoragePersister({
  storage: window.sessionStorage,
  serialize: (data) => compress(preSerialize(data)),
  deserialize: (data) => preDeserialize(decompress(data)),
});

persistQueryClient({
  queryClient: smallDataQueryClient,
  persister: sessionStoragePersister,
  maxAge: Infinity,
});

export { smallDataQueryClient, sessionStoragePersister };
